/**
 * Enum for user roles
 *
 * Since the uid of the roles of users in the different systems can be different, the names of the roles are used instead to check the
 * access authorization.
 */
export enum UserRole {
	CHAT_USER = 'ChatUser',
	CONTACT_USER = 'ContactUser',
	CUSTOMER_ADMINISTRATOR = 'CustomerAdministrator',
	DENTIST_USER = 'DentistUser',
	LAB_USER = 'LabUser',
	DISCONNECTED_USER = 'DisconnectedUser'
}
